import type { TFunction } from 'i18next';
import type { IAdminManager } from '@apis/adminManagers';
import { tradeLabel } from '@utils/tradeLabel';

/** A manager's role column: their trade, or blank for a trade-less manager. */
export function roleLabel(t: TFunction, manager: IAdminManager): string {
  return manager.tradeId ? tradeLabel(t, manager.tradeId) : '';
}
